import { IconBaseProps, IconType } from "@/types/icon";

export const FilterFillIcon: IconType = ({
  size = 24,
  color = "text-semantic-text-body",
  ...props
}: IconBaseProps) => {
  return (
    <svg
      className={`${color}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        d="M2.14876 3.16364L6.50428 8.90909V11.8182L9.49572 14V8.90909L13.8512 3.16364C13.9343 3.05539 13.9848 2.92664 13.9971 2.79187C14.0094 2.65709 13.9829 2.52163 13.9208 2.40073C13.8587 2.27982 13.7633 2.17826 13.6454 2.10747C13.5274 2.03668 13.3916 1.99946 13.2532 2.00001H2.74675C2.60837 1.99946 2.47258 2.03668 2.35465 2.10747C2.23672 2.17826 2.14132 2.27982 2.07919 2.40073C2.01706 2.52163 1.99065 2.65709 2.00294 2.79187C2.01523 2.92664 2.06573 3.05539 2.14876 3.16364Z"
        fill="#158444"
      />
    </svg>
  );
};

{
  /* <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">

</svg> */
}
